export default __webpack_public_path__ + "static/media/location.1646bf59.svg";